module.exports = __webpack_public_path__ + "img/honor5.dbe7b30f.png";